class NCGAnnouncementBar {
  constructor() {
    this.track = document.querySelector('[data-marquee-track]');
    if (!this.track) return;
    
    this.init();
  }

  init() {
    this.calculateSpeed();
    
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => this.calculateSpeed(), 250);
    });
  }

  calculateSpeed() {
    const speed = parseInt(this.track.dataset.speed) || 60;
    const slides = this.track.querySelectorAll('.ncg-announcement-bar__slide');
    if (slides.length === 0) return;
    
    const slideCount = slides.length;
    const totalWidth = slides[0].offsetWidth * slideCount;
    const duration = totalWidth / speed;
    
    this.track.style.animationDuration = `${duration}s`;
    
    const percentage = 100 / slideCount;
    let style = document.getElementById('ncg-marquee-keyframes');
    if (!style) {
      style = document.createElement('style');
      style.id = 'ncg-marquee-keyframes';
      document.head.appendChild(style);
    }
    style.innerHTML = `
      @keyframes marquee-scroll {
        0% { transform: translateX(0); }
        100% { transform: translateX(-${percentage}%); }
      }
    `;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new NCGAnnouncementBar();
});